import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CallOutNew from "Component/Headers/callOutNew";
import Select from "react-select";
import CustomLoader from "Component/CustomLoader";

import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import clock from "Assets/Icons/Clock-time/clock-time-16px.svg";
import draft from "Assets/Icons/Draft/draft-outline-16px.svg";
import DefaultProfileImage from "Assets/Images/profile_defaultImg.svg";
import checkRound from "Assets/newicons/notify/check-round/outline/check-round-outline-16px.svg";
import Tooltip from "@material-ui/core/Tooltip";
import { getUrlExtension } from "Handlers/getters";
import { multiselectinputconverter } from "Component/DynamicForm/Fields/MultiSelect";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import { instance, instanceMultipart } from "Actions/AxiosInstance";
import { setPreview as setPreviewAction } from "Actions/commonAction";
import commentIcon from "Assets/newicons/action/comment/outline/comment-outline-16px.svg";
import backArrow from "Assets/newicons/arrow/line-arrow/left/outline/line-arrow-left-outline-16px.svg";
import { radioinputconverter } from "Component/DynamicForm/Fields/Radio";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import LabelIcon from "Component/Labels/LabelIcon";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import { ErrorMessages } from "Constants";
import headersList from "Constants/headersList";
import { withSnackbar } from "notistack";
import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import StarRatingComponent from "Library/react-star-rating-component";
import { bindActionCreators } from "redux";
import { getFormattedImageLink } from "Utils";
import DynamicForm from "../../../../../Component/DynamicForm";
import Forms from "../Forms";
import { FormStatus, getCount, getStatus } from "../Functions";
import "./index.scss";
import attachmentIcon from "Assets/Svg/attachment.svg";
import Dropzone from "react-dropzone";
import Thumbnail from "Component/Thumbnail/ThumbnailSmall";
import {
  removeSaveProgress,
  setSaveProgress,
} from "../../../../../Actions/SaveProgressAction";

const styles = () => ({
  TableRow: {
    borderRadius: 4,
  },
  breadcrumb: {
    background: "#fff",
    borderRadius: 20,
    fontSize: 12,
    padding: "2px 8px",
    width: 102,
    textDecoration: "none !important",
    border: "solid 1px #d9dadb",
    "&:hover, &:focus": {
      border: "solid 1px #1e8ced",
    },
    "&:active": {
      border: "solid 1px #1e8ced",
    },
  },
});

class PendingReviews extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      empform: null,
      qnum: null,
      createmenu: false,
      create_anchorEl: null,
      openDialog: false,
      openDialog1: false,
      empform1: null,
      newattachments: [],
      employeeids: [],
      isloading: false,
    };

    this.editForm = this.editForm.bind(this);
    this.editForm1 = this.editForm1.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onSave1 = this.onSave1.bind(this);
    this.setAnswer = this.setAnswer.bind(this);
    this.takeAction = this.takeAction.bind(this);
    this.getFiles = this.getFiles.bind(this);
    this.openPeerDialog = this.openPeerDialog.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    if (this.props.empform) {
      this.setState({
        empform: this.props.empform,
      });
    }
  }

  componentWillReceiveProps(props) {
    const isSpecialAccess =
      this.props.history.location.pathname.includes("app");
    console.log(
      "props.empform: ",
      props.selectedempid,
      this.props.selectedempid,
    );
    if (
      !isSpecialAccess &&
      this.props.value == 1 &&
      props.selectedempid != this.props.selectedempid
    ) {
      this.setState({
        empform: null,
      });
    }
    if (props.empform) {
      this.setState({
        empform: props.empform,
      });
    }
  }

  openPeerDialog() {
    this.setState({ openDialog1: true });
  }

  getPreferences() {
    instance
      .post("perform/getemployeepreference", {
        participanttype: [4],
        employeeid: null,
      })
      .then((result) => {
        const peersList =
          result.data.result[0].preference &&
          result.data.result[0].preference.map((x) => ({
            displayname: x.fullname,
            displayvalue: x.employeeid,
          }));

        this.setState({
          peersList,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  handleChange(key, value) {
    this.setState({
      [key]: value,
    });
  }

  getRatingScale() {
    instance
      .get(`perform/getratingscale`)
      .then((result) => {
        if (result.data.result.length > 0) {
          const ratings = [
            result.data.result.find((x) => x.ratingscaletypeid == 1),
            result.data.result.find((x) => x.ratingscaletypeid == 2),
            result.data.result.find((x) => x.ratingscaletypeid == 3),
            result.data.result.find((x) => x.ratingscaletypeid == 4),
            result.data.result.find((x) => x.ratingscaletypeid == 5),
          ];
          const threecodes = [];
          const fourcodes = [];
          const fivecodes = [];
          const sevencodes = [];
          const tencodes = [];
          const threepoint = result.data.result.find(
            (rate) => rate.ratingscaletypeid == 1,
          );
          threepoint &&
            Object.keys(threepoint).forEach((key) => {
              if (
                key == "scaleone" ||
                key == "scaletwo" ||
                key == "scalethree"
              ) {
                threecodes.push(threepoint[key]);
              }
            });
          const fourpoint = result.data.result.find(
            (rate) => rate.ratingscaletypeid == 2,
          );
          fourpoint &&
            Object.keys(fourpoint).forEach((key) => {
              if (
                key == "scaleone" ||
                key == "scaletwo" ||
                key == "scalethree" ||
                key == "scalefour"
              ) {
                fourcodes.push(fourpoint[key]);
              }
            });
          const fivepoint = result.data.result.find(
            (rate) => rate.ratingscaletypeid == 3,
          );
          fivepoint &&
            Object.keys(fivepoint).forEach((key) => {
              if (
                key == "scaleone" ||
                key == "scaletwo" ||
                key == "scalethree" ||
                key == "scalefour" ||
                key == "scalefive"
              ) {
                fivecodes.push(fivepoint[key]);
              }
            });
          const sevenpoint = result.data.result.find(
            (rate) => rate.ratingscaletypeid == 4,
          );
          sevenpoint &&
            Object.keys(sevenpoint).forEach((key) => {
              if (
                key == "scaleone" ||
                key == "scaletwo" ||
                key == "scalethree" ||
                key == "scalefour" ||
                key == "scalefive" ||
                key == "scalesix" ||
                key == "scaleseven"
              ) {
                sevencodes.push(sevenpoint[key]);
              }
            });
          const tenpoint = result.data.result.find(
            (rate) => rate.ratingscaletypeid == 5,
          );
          tenpoint &&
            Object.keys(tenpoint).forEach((key) => {
              if (
                key == "scaleone" ||
                key == "scaletwo" ||
                key == "scalethree" ||
                key == "scalefour" ||
                key == "scalefive" ||
                key == "scalesix" ||
                key == "scaleseven" ||
                key == "scaleeight" ||
                key == "scalenine" ||
                key == "scaleten"
              ) {
                tencodes.push(tenpoint[key]);
              }
            });
          this.setState({
            allratings: ratings,
            threecodes,
            fourcodes,
            fivecodes,
            sevencodes,
            tencodes,

            isratingscaledata: true,
          });
        } else {
          this.setState({ isratingscaledata: false });
        }
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  editForm(data) {
    instance
      .get(`perform/getfeedbackform/${data.empreviewdetailid}`)
      .then((result) => {
        this.setState(
          {
            empform: result.data.result[0],
          },
          () => {
            this.getRatingScale();
            result.data.result &&
              result.data.result[0] &&
              result.data.result[0].isemppeerdecide &&
              this.getPreferences();
          },
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  editForm1(data) {
    data &&
      instance
        .get(`perform/getfeedbackform/${data.selfempreviewdetailid}`)
        .then((result) => {
          this.setState(
            {
              empform1: result.data.result[0],
            },
            () => this.getRatingScale(),
          );
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
  }

  setAnswer(question, ans, type) {
    const { empform } = this.state;
    if (empform && empform.question) {
      question.feedback = question.feedback
        ? {
            ...question.feedback,
            reviewfeedbackid: question.feedback.reviewfeedbackid,
            feedback: type == "feedback" ? ans : question.feedback.feedback,
            rating: type == "rating" ? ans : question.feedback.rating,
            questioninputoptionid:
              type == "questioninputoptionid"
                ? ans
                : question.feedback.questioninputoptionid,
          }
        : {
            reviewfeedbackid: null,
            feedback: type == "feedback" ? ans : null,
            rating: type == "rating" ? ans : null,
            questioninputoptionid: type == "questioninputoptionid" ? ans : null,
          };
      const index = empform.question.findIndex(
        (qes) => qes.reviewquestionid == question.reviewquestionid,
      );
      empform.question[index] = question;
      this.setState({
        empform,
      });
    }
  }

  onSave(isdraft) {
    const { empform } = this.state;
    const data = {
      empreviewdetailid: empform && empform.empreviewdetailid,
      empreviewformid: empform && empform.empreviewformid,
      reviewformid: empform && empform.reviewformid,
      participantemployeeid: empform && empform.participantemployeeid,
      peeremployeeids:
        this.state.employeeids.length > 0
          ? this.state.employeeids.map((x) => x.displayvalue)
          : null,
      isdraft,
      feedback:
        empform &&
        empform.question &&
        empform.question.map((q) => ({
          iscontributeinrating: q.iscontributeinrating,
          reviewfeedbackid: q.feedback ? q.feedback.reviewfeedbackid : null,
          reviewquestionid: q.reviewquestionid,
          reviewsectionid: q.reviewsectionid,
          focusareaid: q.focusareaid,
          comment: q.feedback ? q.feedback.feedback || null : null,
          ratingscaletypeid: q.ratingscaletypeid ? q.ratingscaletypeid : null,
          ratingscale: getCount(q.ratingscaletypeid),
          rating: q.feedback ? q.feedback.rating || null : null,
          questioninputtypeid: q.questioninputtypeid,
          questioninputoptionid:
            q.questioninputtypeid == 2
              ? q.feedback
                ? q.feedback.questioninputoptionid || null
                : null
              : null,
          files: q.feedback ? q.feedback.files : null,
        })),
    };

    if (
      !isdraft &&
      data.feedback.find((f) =>
        f.iscontributeinrating
          ? !f.rating
          : f.questioninputtypeid == 1
          ? !f.comment
          : !f.questioninputoptionid,
      )
    ) {
      this.props.enqueueSnackbar(ErrorMessages.E0020, { variant: "error" });
    } else {
      data.feedback = !isdraft
        ? data.feedback
            .filter((f) =>
              f.iscontributeinrating
                ? f.rating
                : f.questioninputtypeid == 1
                ? f.comment
                : f.questioninputoptionid,
            )
            .map((q) => ({
              reviewfeedbackid: q.reviewfeedbackid,
              reviewquestionid: q.reviewquestionid,
              reviewsectionid: q.reviewsectionid,
              focusareaid: q.focusareaid,
              comment: q.comment,
              ratingscaletypeid: q.ratingscaletypeid,
              ratingscale: q.ratingscale,
              rating: q.rating,
              questioninputoptionid: q.questioninputoptionid,
              files: q.files,
            }))
        : data.feedback
            .filter(
              (f) =>
                (f.iscontributeinrating
                  ? f.rating
                  : f.questioninputtypeid == 1
                  ? f.comment
                  : f.questioninputoptionid) || f.comment,
            )
            .map((q) => ({
              reviewfeedbackid: q.reviewfeedbackid,
              reviewquestionid: q.reviewquestionid,
              reviewsectionid: q.reviewsectionid,
              focusareaid: q.focusareaid,
              comment: q.comment,
              ratingscaletypeid: q.ratingscaletypeid,
              ratingscale: q.ratingscale,
              rating: q.rating,
              questioninputoptionid: q.questioninputoptionid,
              files: q.files,
            }));
      this.props.enqueueSnackbar("Are you sure you want to submit?", {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              this.props.closeSnackbar();
              const { issaveinprogress } = this.props.SaveInProgressReducer;

              if (!issaveinprogress) {
                this.props.setSaveProgress(true);
                this.setState({ isloading: true }, () => {
                  instance
                    .post(`perform/submitfeedbackform`, data)
                    .then(() => {
                      this.props.removeSaveProgress();
                      this.setState(
                        {
                          empform: null,
                          openDialog1: false,
                          isloading: false,
                        },
                        () => {
                          this.props.getForms({
                            employeeid:
                              this.props.value == 1
                                ? this.props.selectedempid
                                : empform && empform.employeeid,
                          });
                        },
                      );
                      this.props.enqueueSnackbar(
                        isdraft
                          ? "Saved as draft successfully"
                          : ErrorMessages.E0000,
                        { variant: "success" },
                      );
                    })
                    .catch((error) => {
                      this.props.removeSaveProgress();
                      this.setState({ isloading: false });
                      this.props.enqueueSnackbar(
                        error.response
                          ? error.response.data.error.message
                          : error.message,
                        { variant: "error" },
                      );
                    });
                });
              }
            }}
          >
            Yes
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            No
          </Button>,
        ],
      });
    }

    // instance
    //   .post(`perform/submitfeedbackform`, data)
    //   .then(() => {
    //     this.setState(
    //       {
    //         empform: null,
    //       },
    //       () => {
    //         this.props.getForms({
    //           employeeid:
    //             this.props.value == 1
    //               ? this.props.selectedempid
    //               : empform && empform.employeeid,
    //         });
    //       },
    //     );
    //     this.props.enqueueSnackbar(
    //       isdraft ? "Saved as draft successfully" : ErrorMessages.E0000,
    //       { variant: "success" },
    //     );
    //   })
    //   .catch((error) => {
    //     this.props.enqueueSnackbar(
    //       error.response ? error.response.data.error.message : error.message,
    //       { variant: "error" },
    //     );
    //   });
  }

  onSave1(isdraft) {
    const { empform } = this.state;
    const data = {
      empreviewdetailid: empform && empform.empreviewdetailid,
      empreviewformid: empform && empform.empreviewformid,
      reviewformid: empform && empform.reviewformid,
      participantemployeeid: empform && empform.participantemployeeid,
      peeremployeeids:
        this.state.employeeids.length > 0
          ? this.state.employeeids.map((x) => x.displayvalue)
          : null,
      isdraft,
      feedback:
        empform &&
        empform.question &&
        empform.question.map((q) => ({
          iscontributeinrating: q.iscontributeinrating,
          reviewfeedbackid: q.feedback ? q.feedback.reviewfeedbackid : null,
          reviewquestionid: q.reviewquestionid,
          reviewsectionid: q.reviewsectionid,
          focusareaid: q.focusareaid,
          comment: q.feedback ? q.feedback.feedback || null : null,
          ratingscaletypeid: q.ratingscaletypeid ? q.ratingscaletypeid : null,
          ratingscale: getCount(q.ratingscaletypeid),
          rating: q.feedback ? q.feedback.rating || null : null,
          questioninputtypeid: q.questioninputtypeid,
          questioninputoptionid:
            q.questioninputtypeid == 2
              ? q.feedback
                ? q.feedback.questioninputoptionid || null
                : null
              : null,
          files: q.feedback ? q.feedback.files : null,
        })),
    };

    if (
      empform.isemppeerdecide &&
      !isdraft &&
      data.feedback.find((f) =>
        f.iscontributeinrating
          ? f.rating
          : f.questioninputtypeid == 1
          ? f.comment
          : f.questioninputoptionid,
      )
    ) {
      this.openPeerDialog();
    } else if (
      !isdraft &&
      data.feedback.find((f) =>
        f.iscontributeinrating
          ? !f.rating
          : f.questioninputtypeid == 1
          ? !f.comment
          : !f.questioninputoptionid,
      )
    ) {
      this.props.enqueueSnackbar(ErrorMessages.E0020, { variant: "error" });
    } else {
      data.feedback = !isdraft
        ? data.feedback
            .filter((f) =>
              f.iscontributeinrating
                ? f.rating
                : f.questioninputtypeid == 1
                ? f.comment
                : f.questioninputoptionid,
            )
            .map((q) => ({
              reviewfeedbackid: q.reviewfeedbackid,
              reviewquestionid: q.reviewquestionid,
              reviewsectionid: q.reviewsectionid,
              focusareaid: q.focusareaid,
              comment: q.comment,
              ratingscaletypeid: q.ratingscaletypeid,
              ratingscale: q.ratingscale,
              rating: q.rating,
              questioninputoptionid: q.questioninputoptionid,
              files: q.files,
            }))
        : data.feedback
            .filter(
              (f) =>
                (f.iscontributeinrating
                  ? f.rating
                  : f.questioninputtypeid == 1
                  ? f.comment
                  : f.questioninputoptionid) || f.comment,
            )
            .map((q) => ({
              reviewfeedbackid: q.reviewfeedbackid,
              reviewquestionid: q.reviewquestionid,
              reviewsectionid: q.reviewsectionid,
              focusareaid: q.focusareaid,
              comment: q.comment,
              ratingscaletypeid: q.ratingscaletypeid,
              ratingscale: q.ratingscale,
              rating: q.rating,
              questioninputoptionid: q.questioninputoptionid,
              files: q.files,
            }));
    }
  }

  ConfirmSave(isdraft) {
    const { empform } = this.state;
    const data = {
      empreviewdetailid: empform && empform.empreviewdetailid,
      empreviewformid: empform && empform.empreviewformid,
      reviewformid: empform && empform.reviewformid,
      participantemployeeid: empform && empform.participantemployeeid,
      peeremployeeids:
        this.state.employeeids.length > 0
          ? this.state.employeeids.map((x) => x.displayvalue)
          : null,
      isdraft,
      feedback:
        empform &&
        empform.question &&
        empform.question.map((q) => ({
          // iscontributeinrating: q.iscontributeinrating,
          reviewfeedbackid: q.feedback ? q.feedback.reviewfeedbackid : null,
          reviewquestionid: q.reviewquestionid,
          reviewsectionid: q.reviewsectionid,
          focusareaid: q.focusareaid,
          comment: q.feedback ? q.feedback.feedback || null : null,
          ratingscaletypeid: q.ratingscaletypeid ? q.ratingscaletypeid : null,
          ratingscale: getCount(q.ratingscaletypeid),
          rating: q.feedback ? q.feedback.rating || null : null,
          // questioninputtypeid: q.questioninputtypeid,
          questioninputoptionid:
            q.questioninputtypeid == 2
              ? q.feedback
                ? q.feedback.questioninputoptionid || null
                : null
              : null,
          files: q.feedback ? q.feedback.files : null,
        })),
    };

    this.props.enqueueSnackbar("Are you sure you want to submit?", {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            this.props.closeSnackbar();
            const { issaveinprogress } = this.props.SaveInProgressReducer;

            if (!issaveinprogress) {
              this.props.setSaveProgress(true);
              this.setState({ isConfirmSavedLoading: true }, () => {
                instance
                  .post(`perform/submitfeedbackform`, data)
                  .then(() => {
                    this.setState(
                      {
                        empform: null,
                        openDialog1: false,
                        isConfirmSavedLoading: false,
                      },
                      () => {
                        this.props.getForms({
                          employeeid:
                            this.props.value == 1
                              ? this.props.selectedempid
                              : empform && empform.employeeid,
                        });
                      },
                    );
                    this.props.enqueueSnackbar(
                      isdraft
                        ? "Saved as draft successfully"
                        : ErrorMessages.E0000,
                      { variant: "success" },
                    );
                  })
                  .catch((error) => {
                    this.setState({ isConfirmSavedLoading: false });
                    this.props.enqueueSnackbar(
                      error.response
                        ? error.response.data.error.message
                        : error.message,
                      { variant: "error" },
                    );
                  });
              });
            }
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  }

  takeAction(form, id) {
    console.log("form: ", form);
    const { selectedemp } = this.props;
    const data = {
      actionid: id,
      empreviewformid: selectedemp && selectedemp.empreviewformid,
      empreviewdetailid: form.empreviewdetailid,
    };
    this.setState(
      {
        createmenu: false,
        create_anchorEl: null,
      },
      () => {
        this.props.takeAction(form, data);
      },
    );
  }

  getFiles(files, question) {
    const { empform } = this.state;
    const formData = new FormData();
    files.forEach((fil) => {
      formData.append("file", fil);
    });

    const index = this.state.empform.question.findIndex(
      (qes) => qes.reviewquestionid == question.reviewquestionid,
    );

    if (
      (question.feedback.files && question.feedback.files.length >= 2) ||
      files.length > 2
    ) {
      this.props.enqueueSnackbar("Maximum file upload limit exceed", {
        variant: "error",
      });

      return false;
    } else {
      instanceMultipart
        .post(
          `/drive/uploaddocument/${this.props.SubscriptionData.subscriptionid}/${this.props.login.employeeid}`,
          formData,
        )
        .then((resp) => {
          resp.data.result.forEach((item) => {
            const filenName = files[0].name.substr(
              0,
              files[0].name.lastIndexOf("."),
            );

            const obj = {
              filename: filenName,
              filepath: resp.data.result[0].imagepath,
              fileextension: resp.data.result[0].extension,
            };

            if (!empform.question[index].feedback.files) {
              empform.question[index].feedback.files = [];
            }

            empform.question[index].feedback.files.push(obj);

            this.setState({
              empform,
            });
          });
        });
    }
  }

  onDeleteAttachment(index, qid) {
    const all = this.state.empform;

    const qindex = this.state.empform.question.findIndex(
      (qes) => qes.reviewquestionid == qid,
    );

    all.question[qindex].feedback.files.splice(index, 1);
    this.setState({
      empform: all,
    });
  }

  render() {
    const {
      forms,
      performcycles,
      cycleid,
      threecodes,
      fourcodes,
      fivecodes,
      value,
      selectedemp,
      actionemp,
      empList,
      isoverview,
    } = this.props;
    const { empform, empform1 } = this.state;
    const isSpecialAccess =
      this.props.history.location.pathname.includes("app");
    const selectedcycle = performcycles.find(
      (c) => c.performcycledurationid == cycleid,
    );
    const selecteddata =
      empform &&
      forms.find((data) => data.empreviewdetailid == empform.empreviewdetailid);
    const getCountForEmoji = (id) => {
      if (id == 1) return threecodes;
      if (id == 2) return fourcodes;
      if (id == 3) return fivecodes;
    };
    const isEnable = () =>
      empform &&
      (empform.formstatusid == 1 || empform.formstatusid == 2) &&
      getStatus(selecteddata) != FormStatus.CLOSED &&
      !isSpecialAccess;
    console.log(selectedemp);

    const { issaveinprogress } = this.props.SaveInProgressReducer;

    return (
      <div>
        <Helmet>
          <title>{headersList.Perform.EmployeeReviews.header}</title>
        </Helmet>
        {empform ? (
          <Grid container style={{ marginBottom: 24 }}>
            {!isSpecialAccess && (
              <Grid item md={12} sm={12} style={{ padding: 2 }}>
                <Paper
                  className="rounded-rectangle-paper padding16"
                  style={{ height: "auto" }}
                >
                  <div className="margin-bottom-16">
                    <span
                      className="floatleft margin-right-16 cursor-pointer"
                      onClick={() => {
                        const temp = empform;
                        this.setState({ empform: null }, () => {
                          this.props.clearForms(temp.employeeid);
                        });
                      }}
                    >
                      <img src={backArrow}></img>
                    </span>
                    <span className="floatleft normal-dark-secondary t-bold">
                      {empform.formtitle}
                    </span>
                    <div className="clear-float"></div>
                  </div>
                  <Grid container>
                    <Grid item md={4} sm={12}>
                      <Popover
                        open={this.state.createmenu}
                        anchorEl={this.state.create_anchorEl}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                        // onClose={this.createNewMenuClose}
                        className="margin-top-8"
                      >
                        <Paper>
                          <div>
                            <List style={{ padding: "4px 0px 4px 0px" }}>
                              {/* {sortOptinos.map((option) => ( */}
                              <ListItem
                                button
                                className="padding-top-0 padding-bottom-0 padding-left-12 padding-right-12 cursor-pointer"
                                // onClick={() => this.setSortName(displayvalue)}
                              >
                                <ListItemText style={{ padding: 0 }}>
                                  <span className="small-dark-secondary">
                                    Job description
                                  </span>
                                </ListItemText>
                              </ListItem>
                              <ListItem
                                button
                                className="padding-top-0 padding-bottom-0 padding-left-12 padding-right-12 cursor-pointer"
                                // onClick={this.setSection}
                              >
                                <ListItemText style={{ padding: 0 }}>
                                  <span className="small-dark-secondary">
                                    Section A
                                  </span>
                                </ListItemText>
                              </ListItem>
                              <ListItem
                                button
                                className="padding-top-0 padding-bottom-0 padding-left-12 padding-right-12 cursor-pointer"

                                // onClick={() => this.setSortName(displayvalue)}
                              >
                                <ListItemText style={{ padding: 0 }}>
                                  <span className="small-dark-secondary">
                                    Section B
                                  </span>
                                </ListItemText>
                              </ListItem>
                              {/* ))} */}
                            </List>
                          </div>
                        </Paper>
                      </Popover>
                    </Grid>
                    <Grid
                      item
                      md={8}
                      sm={12}
                      className="display-flex"
                      justify="flex-end"
                    >
                      {selecteddata && selecteddata.formbar && (
                        <span
                          style={{ display: "inline-block", marginRight: 16 }}
                        >
                          {parseInt(
                            (parseInt(selecteddata.formbar.totalfeedback) /
                              parseInt(selecteddata.formbar.totalquestion)) *
                              100,
                          )}
                          {"%"}
                        </span>
                      )}
                      {selecteddata && selecteddata.formbar && (
                        <span
                          style={{
                            display: "inline-block",
                            width: 200,
                            marginRight: 16,
                            marginTop: 10,
                          }}
                        >
                          <LinearProgress
                            variant="determinate"
                            value={
                              (parseInt(selecteddata.formbar.totalfeedback) /
                                parseInt(selecteddata.formbar.totalquestion)) *
                              100
                            }
                          />
                        </span>
                      )}
                      <span
                        className="small-text-blue"
                        style={{
                          color:
                            getStatus(selecteddata) == FormStatus.SUBMIT
                              ? "#008985"
                              : getStatus(selecteddata) == FormStatus.RELEASE
                              ? "#A9A9A9"
                              : getStatus(selecteddata) == FormStatus.OPEN
                              ? "#1e8ced"
                              : getStatus(selecteddata) == FormStatus.OPENDRAFT
                              ? "#1e8ced"
                              : getStatus(selecteddata) == FormStatus.CLOSED
                              ? "#ff4052"
                              : // : getStatus(selecteddata) == FormStatus.DUESOON
                                // ? "#ad0e46"
                                "#ad0e46",
                        }}
                      >
                        {getStatus(selecteddata)}
                      </span>
                    </Grid>
                  </Grid>
                  {/* {value == 1 && empform.selfempreviewdetailid && ( */}
                  {empform.selfempreviewdetailid && (
                    <div
                      style={{
                        textAlign: "right",
                        marginTop: 8,
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        this.setState({ openDialog: true }, () => {
                          this.editForm1(empform);
                        })
                      }
                    >
                      <p className="small-blue">
                        View this employee’s self review
                      </p>
                    </div>
                  )}
                </Paper>
              </Grid>
            )}
            {!isSpecialAccess && (
              <Grid
                item
                md={12}
                sm={12}
                style={{ padding: 2 }}
                className="margin-top-16 margin-bottom-16"
              >
                <Paper className="rounded-rectangle-paper padding16">
                  <div>
                    <div className="floatleft">
                      <div className="floatleft margin-right-16">
                        <ProfilePicture
                          src={getFormattedImageLink(empform.imagepath)}
                          height="48"
                        />
                      </div>
                      <div className="floatleft">
                        <span className="large-dark-secondary display-block margin-bottom-8">
                          {empform.fullname}
                        </span>
                        <span className="small-dark-secondary">
                          {empform.designationname}
                        </span>
                      </div>
                    </div>
                    <div className="clear-float"></div>
                  </div>
                </Paper>
              </Grid>
            )}

            {isoverview ? (
              <div className="width100">
                <p className="normal-dark-secondary t-bold margin-bottom-8">
                  overview
                </p>
                <p className="small-dark-secondary margin-bottom-32">
                  Employees pending completion of review form
                </p>
                <div
                  className="rounded-rectangle-div padding16 display-flex"
                  style={{ alignItems: "flex-start" }}
                >
                  <img src={clock} className="margin-right-16"></img>
                  <div>
                    <p className="small-dark-secondary margin-bottom-16">
                      Pending completion
                    </p>
                    <Grid container>
                      <Grid item md={4}>
                        <div
                          className="display-flex"
                          style={{ alignItems: "center" }}
                        >
                          <ProfilePicture
                            // src={getFormattedImageLink(empform.imagepath)}
                            src={DefaultProfileImage}
                            height="24"
                          />
                          <p className="small-dark-secondary margin-left-8">
                            Name
                          </p>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </div>
                <div
                  className="rounded-rectangle-div padding16 display-flex margin-top-24"
                  style={{ alignItems: "flex-start" }}
                >
                  <img src={checkRound} className="margin-right-16"></img>
                  <div>
                    <p className="small-dark-secondary margin-bottom-16">
                      Submitted review
                    </p>
                    <Grid container>
                      <Grid item md={4}>
                        <div
                          className="display-flex"
                          style={{ alignItems: "center" }}
                        >
                          <ProfilePicture
                            // src={getFormattedImageLink(empform.imagepath)}
                            src={DefaultProfileImage}
                            height="24"
                          />
                          <p className="small-dark-secondary margin-left-8">
                            Name
                          </p>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </div>
            ) : (
              <div className="width100">
                {empform &&
                  empform.question &&
                  empform.question.map((q, index) => (
                    <Grid
                      item
                      md={12}
                      sm={12}
                      className="question-section margin-bottom-16"
                    >
                      <p className="extra-small-dark t-bold margin-bottom-4">
                        {q.sectionname} / {q.competencyname}
                      </p>
                      <Paper className="rounded-rectangle-paper padding16">
                        <p className="small-dark margin-bottom-4">
                          {index + 1}. {q.question}
                        </p>
                        <p
                          className="extra-small-dark margin-bottom-8"
                          style={{ whiteSpace: "pre-line" }}
                        >
                          {q.description}
                        </p>
                        <div className="floatleft width100">
                          {q.iscontributeinrating &&
                            q.ratingtypeid == 1 &&
                            getCount(q.ratingscaletypeid) &&
                            Array.from(
                              Array(getCount(q.ratingscaletypeid)),
                              (val, index1) => index1 + 1,
                            ).map((num, numindex) => (
                              <div className="floatleft">
                                <Tooltip
                                  title={
                                    getCount(q.ratingscaletypeid) == 3
                                      ? this.state.threecodes &&
                                        this.state.threecodes[numindex]
                                      : getCount(q.ratingscaletypeid) == 4
                                      ? this.state.fourcodes &&
                                        this.state.fourcodes[numindex]
                                      : getCount(q.ratingscaletypeid) == 5
                                      ? this.state.fivecodes &&
                                        this.state.fivecodes[numindex]
                                      : getCount(q.ratingscaletypeid) == 7
                                      ? this.state.sevencodes &&
                                        this.state.sevencodes[numindex]
                                      : getCount(q.ratingscaletypeid) == 10
                                      ? this.state.tencodes &&
                                        this.state.tencodes[numindex]
                                      : ""
                                  }
                                  placement="top"
                                >
                                  <div
                                    className={
                                      true
                                        ? q.feedback && q.feedback.rating == num
                                          ? "rating-scale-points-selected"
                                          : "rating-scale-points"
                                        : "rating-scale-points-disabled"
                                    }
                                    onClick={() =>
                                      isEnable() &&
                                      this.setAnswer(q, num, "rating")
                                    }
                                  >
                                    <span>{num}</span>
                                  </div>
                                </Tooltip>
                                <div className="clear-float"></div>
                              </div>
                            ))}
                          {q.iscontributeinrating &&
                            q.ratingtypeid == 2 &&
                            getCount(q.ratingscaletypeid) && (
                              <Tooltip
                                title={
                                  getCount(q.ratingscaletypeid) == 3
                                    ? this.state.threecodes &&
                                      this.state.threecodes[
                                        this.state.intstarhover - 1
                                      ]
                                    : getCount(q.ratingscaletypeid) == 4
                                    ? this.state.fourcodes &&
                                      this.state.fourcodes[
                                        this.state.intstarhover - 1
                                      ]
                                    : getCount(q.ratingscaletypeid) == 5
                                    ? this.state.fivecodes &&
                                      this.state.fivecodes[
                                        this.state.intstarhover - 1
                                      ]
                                    : getCount(q.ratingscaletypeid) == 7
                                    ? this.state.sevencodes &&
                                      this.state.sevencodes[
                                        this.state.intstarhover - 1
                                      ]
                                    : getCount(q.ratingscaletypeid) == 10
                                    ? this.state.tencodes &&
                                      this.state.tencodes[
                                        this.state.intstarhover - 1
                                      ]
                                    : ""
                                }
                                placement="top"
                              >
                                <div
                                  className="dv-star-rating-outer"
                                  style={{ width: 168 }}
                                >
                                  <StarRatingComponent
                                    name="rate1"
                                    starCount={getCount(q.ratingscaletypeid)}
                                    value={q.feedback ? q.feedback.rating : ""}
                                    onStarClick={(value) =>
                                      isEnable() &&
                                      this.setAnswer(q, value, "rating")
                                    }
                                    onStarHover={(value) =>
                                      this.setState({ intstarhover: value })
                                    }
                                  />
                                </div>
                              </Tooltip>
                            )}
                          {q.iscontributeinrating &&
                            q.ratingtypeid == 3 &&
                            getCountForEmoji(q.ratingscaletypeid) &&
                            getCountForEmoji(q.ratingscaletypeid).map(
                              (emoji, index1) => (
                                <div className="floatleft">
                                  <Tooltip
                                    title={
                                      getCount(q.ratingscaletypeid) == 3
                                        ? this.state.threecodes &&
                                          this.state.threecodes[index1]
                                        : getCount(q.ratingscaletypeid) == 4
                                        ? this.state.fourcodes &&
                                          this.state.fourcodes[index1]
                                        : getCount(q.ratingscaletypeid) == 5
                                        ? this.state.fivecodes &&
                                          this.state.fivecodes[index1]
                                        : getCount(q.ratingscaletypeid) == 7
                                        ? this.state.sevencodes &&
                                          this.state.sevencodes[index1]
                                        : getCount(q.ratingscaletypeid) == 10
                                        ? this.state.tencodes &&
                                          this.state.tencodes[index1]
                                        : ""
                                    }
                                    placement="top"
                                  >
                                    <div
                                      className={
                                        true
                                          ? q.feedback &&
                                            q.feedback.rating == index1 + 1
                                            ? "rating-scale-points-selected"
                                            : "rating-scale-points"
                                          : "rating-scale-points-disabled"
                                      }
                                      onClick={() =>
                                        isEnable() &&
                                        this.setAnswer(q, index1 + 1, "rating")
                                      }
                                    >
                                      {String.fromCodePoint(
                                        parseInt(emoji, 16),
                                      )}
                                    </div>
                                  </Tooltip>
                                  <div className="clear-float"></div>
                                </div>
                              ),
                            )}
                          {!q.iscontributeinrating &&
                            q.questioninputtypeid == 2 &&
                            q.questioninputoption &&
                            q.questioninputoption.map((op) => (
                              <div>
                                <span className="floatleft margin-right-8">
                                  <DynamicForm
                                    className="width50"
                                    fields={radioinputconverter({
                                      value:
                                        q.feedback &&
                                        q.feedback.questioninputoptionid ==
                                          op.questioninputoptionid
                                          ? true
                                          : false,
                                      placeholder: "",
                                      label: "",
                                      disabled: !isEnable(),
                                    })}
                                    onChange={() =>
                                      isEnable() &&
                                      this.setAnswer(
                                        q,
                                        op.questioninputoptionid,
                                        "questioninputoptionid",
                                      )
                                    }
                                  />
                                </span>
                                <span className="small-dark-secondary margin-bottom-8">
                                  {op.optionname}
                                </span>
                                <div className="clear-float"></div>
                              </div>
                            ))}
                          {!q.iscontributeinrating &&
                            q.questioninputtypeid == 1 &&
                            q.sizetypeid == 1 &&
                            empform &&
                            (empform.formstatusid == 1 ||
                              empform.formstatusid == 2) &&
                            !isSpecialAccess && (
                              <div className="width100">
                                <DynamicForm
                                  className="width100"
                                  fields={textinputconverter({
                                    value: q.feedback && q.feedback.feedback,
                                    placeholder: "",
                                    label: "",
                                    maxLength: 50,
                                  })}
                                  onChange={(value) =>
                                    this.setAnswer(q, value, "feedback")
                                  }
                                />
                              </div>
                            )}
                          {!q.iscontributeinrating &&
                            q.questioninputtypeid == 1 &&
                            q.sizetypeid == 2 &&
                            empform &&
                            (empform.formstatusid == 1 ||
                              empform.formstatusid == 2) &&
                            !isSpecialAccess && (
                              <div className="width100">
                                <DynamicForm
                                  className="width100"
                                  fields={textareainputconverter({
                                    value: q.feedback && q.feedback.feedback,
                                    placeholder: "",
                                    label: "",
                                    maxLength: 500,
                                  })}
                                  onChange={(value) =>
                                    this.setAnswer(q, value, "feedback")
                                  }
                                />
                              </div>
                            )}
                          {/* {q.iscontributeinrating
                  && <p className="extra-small-blue t-bold margin-left-16 margin-top-4 floatleft rating-scale-view cursor-pointer">
                    View rating scale
                  </p>} */}
                          {empform &&
                            (empform.formstatusid == 3 ||
                              empform.formstatusid == 4 ||
                              isSpecialAccess) &&
                            q.feedback &&
                            q.feedback.feedback && (
                              <div className="clear-float margin-top-32">
                                <span className="small-dark-secondary t-bold">
                                  Comment:{" "}
                                </span>
                                <span className="small-dark-secondary">
                                  {q.feedback.feedback}
                                </span>
                              </div>
                            )}
                        </div>
                          {isEnable() && !q.sizetypeid && (
                          <div
                            className="floatright comment-section"
                            // onClick={() =>
                            //   this.setState({ qnum: q.reviewquestionid })
                            // }
                          >
                            <div
                              className="floatleft margin-right-32"
                              onClick={() =>
                                this.setState({ fileqid: q.reviewquestionid })
                              }
                            >
                              <Tooltip title=" Note: Upload attachment with max size 2 MB (Supports .xls,.xlsx,.pdf,.doc,.docx file types)">
                                <Dropzone
                                  onDrop={(file) => this.getFiles(file, q)}
                                  multiple={true}
                                  accept=".pdf, .xlsx,.xls,.doc,.docx"
                                  maxSize={2000000}
                                  maxFiles={2}
                                  className="drag-drop"
                                  disabled={!q.feedback}
                                >
                                  <div
                                    className="display-flex"
                                    style={{
                                      alignItems: "center",
                                      pointerEvents: !q.feedback ? "none" : "",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <img
                                      src={attachmentIcon}
                                      height="16"
                                      width="16"
                                      style={{ marginRight: 8 }}
                                    ></img>
                                    <span className="small-dark-secondary">
                                      Attachment
                                    </span>
                                  </div>
                                </Dropzone>
                              </Tooltip>
                            </div>
                            <div
                              onClick={() =>
                                this.setState({ qnum: q.reviewquestionid })
                              }
                            >
                              <LabelIcon
                                className="t-12 cursour-pointer floatleft"
                                label="Comment"
                                img={commentIcon}
                              />

                            </div>
                          </div>
                        )}
                        <div className="clear-float"></div>
                        {this.state.qnum == q.reviewquestionid &&
                          !q.sizetypeid &&
                          empform &&
                          (empform.formstatusid == 1 ||
                            empform.formstatusid == 2) && (
                            <div className="margin-top-8 width100">
                              <DynamicForm
                                className="width50"
                                fields={textareainputconverter({
                                  value: q.feedback && q.feedback.feedback,
                                  placeholder: "",
                                  label: "",
                                  maxLength: 500,
                                })}
                                onChange={(value) =>
                                  this.setAnswer(q, value, "feedback")
                                }
                              />
                            </div>
                          )}

                        {q && q.feedback && q.feedback.files && (
                          <div style={{ height: 50, marginTop: 16 }}>
                            {q &&
                              q.feedback &&
                              q.feedback.files &&
                              q.feedback.files.map((img, imgindex) => (
                                <Thumbnail
                                  canDelete={isEnable() ? true : false}
                                  key="i"
                                  doc={{ url: img.filepath }}
                                  onDeleteAttachment={() =>
                                    this.onDeleteAttachment(
                                      imgindex,
                                      q.reviewquestionid,
                                    )
                                  }
                                />
                              ))}
                          </div>
                        )}
                      </Paper>
                    </Grid>
                  ))}
              </div>
            )}
          </Grid>
        ) : (
          <div className="thin-scroll">
            {(!isSpecialAccess || (isSpecialAccess && value != 0)) && (
              <div>
                {/* {forms.length > 0 ? ( */}
                <Forms
                  selectedcycle={selectedcycle}
                  forms={forms}
                  cycleid={this.props.cycleid}
                  empList={empList}
                  openForm={
                    isSpecialAccess ? this.props.getForm : this.editForm
                  }
                  isSpecialAccess={isSpecialAccess}
                  value={value}
                  getForms={this.props.getForms}
                  get360Employees={this.props.get360Employees}
                  HelperSliderFlag={this.props.HelperSliderFlag}
                  datareceived={this.props.datareceived}
                />
                {/* ) : (
                  <div
                    style={{ height: "77vh" }}
                    className="position-rel margin-top-16"
                  >
                    <DefaultComp
                      //  text={this.getText()}
                      heading={"There are no reviews!"}
                      subheading={
                        "Reviews will appear once you have been assigned a review form."
                      }
                      imageSrc={emp360}
                    />
                  </div>
                )} */}
              </div>
            )}
          </div>
        )}
        {isEnable() && (
          <div
            className="width100"
            style={{
              position: "fixed",
              left: 0,
              background: "white",
              bottom: 0,
              padding: 10,
              borderTop: "1px solid #d4d4d4",
              zIndex: 0,
            }}
          >
            <div>
              <div className="floatleft" style={{ marginLeft: 304 }}>
                <Button
                  className="btn btn-secondary-md-blue margin-right-16"
                  variant="contained"
                  onClick={() =>
                    this.setState({
                      empform: null,
                      qnum: null,
                    })
                  }
                >
                  Cancel
                </Button>
                {/* {this.state.permissions.editable && ( */}
                <Button
                  className={
                    this.props.SaveInProgressReducer.issaveinprogress
                      ? "btn btn-secondary-md-grey margin-right-16"
                      : "btn btn-primary-md-blue margin-right-16"
                  }
                  variant="contained"
                  onClick={() => this.onSave(true)}
                  disabled={this.props.SaveInProgressReducer.issaveinprogress}
                >
                  Save as draft
                </Button>
                {/* )} */}
              </div>
              <div className="floatright" style={{ marginRight: 72 }}>
                {/* {this.state.permissions.editable && ( */}

                <div>
                  {empform.isemppeerdecide && !this.props.selectedempid ? (
                    <Button
                      className={
                        this.props.SaveInProgressReducer.issaveinprogress
                          ? "btn btn-secondary-md-grey margin-right-16"
                          : "btn btn-primary-md-blue margin-right-16"
                      }
                      variant="contained"
                      // onClick={() => this.onSave(false)}
                      onClick={() => this.onSave1(false)}
                      disabled={
                        this.props.SaveInProgressReducer.issaveinprogress
                      }
                    >
                      Save
                    </Button>
                  ) : (
                    <Button
                      className={
                        this.props.SaveInProgressReducer.issaveinprogress
                          ? "btn btn-secondary-md-grey margin-right-16"
                          : "btn btn-primary-md-blue margin-right-16"
                      }
                      variant="contained"
                      onClick={() => this.onSave(false)}
                      disabled={
                        this.props.SaveInProgressReducer.issaveinprogress
                      }
                    >
                      Save
                    </Button>
                  )}
                </div>
                {/* )} */}
              </div>
              <div className="clearfloat"></div>
            </div>
          </div>
        )}
        <Dialog
          fullWidth
          maxWidth="md"
          open={this.state.openDialog}
          onClose={() => this.setState({ openDialog: false, empform1: null })}
        >
          <DialogContent>
            {empform1 &&
              empform1.question &&
              empform1.question.map((q, index) => (
                <Grid
                  item
                  md={12}
                  sm={12}
                  className="margin-bottom-16 question-section"
                >
                  <p className="extra-small-dark-disabled t-bold margin-bottom-4">
                    {q.sectionname} / {q.competencyname}
                  </p>
                  <Paper className="rounded-rectangle-paper padding16">
                    <p className="small-dark margin-bottom-4">
                      {index + 1}. {q.question}
                    </p>
                    <p className="extra-small-dark margin-bottom-8">
                      {q.description}
                    </p>
                    <div className="floatleft">
                      {q.iscontributeinrating &&
                        q.ratingtypeid == 1 &&
                        getCount(q.ratingscaletypeid) &&
                        Array.from(
                          Array(getCount(q.ratingscaletypeid)),
                          (val, index1) => index1 + 1,
                        ).map((num) => (
                          <div className="floatleft">
                            <div
                              className={
                                true
                                  ? q.feedback && q.feedback.rating == num
                                    ? "rating-scale-points-selected"
                                    : "rating-scale-points"
                                  : "rating-scale-points-disabled"
                              }
                              // onClick={() => isEnable() && this.setAnswer(q, num, "rating")}
                            >
                              <span>{num}</span>
                            </div>
                            <div className="clear-float"></div>
                          </div>
                        ))}
                      {q.iscontributeinrating &&
                        q.ratingtypeid == 2 &&
                        getCount(q.ratingscaletypeid) && (
                          <div className="floatleft dv-star-rating-outer">
                            <StarRatingComponent
                              name="rate1"
                              starCount={getCount(q.ratingscaletypeid)}
                              value={q.feedback ? q.feedback.rating : ""}
                              // onStarClick={(value) => isEnable() && this.setAnswer(q, value, "rating")}
                            />
                          </div>
                        )}
                      {q.iscontributeinrating &&
                        q.ratingtypeid == 3 &&
                        getCountForEmoji(q.ratingscaletypeid) &&
                        getCountForEmoji(q.ratingscaletypeid).map(
                          (emoji, index1) => (
                            <div className="floatleft">
                              <div
                                className={
                                  true
                                    ? q.feedback &&
                                      q.feedback.rating == index1 + 1
                                      ? "rating-scale-points-selected"
                                      : "rating-scale-points"
                                    : "rating-scale-points-disabled"
                                }
                                // onClick={() => isEnable() && this.setAnswer(q, index1 + 1, "rating")}
                              >
                                {String.fromCodePoint(parseInt(emoji, 16))}
                              </div>
                              <div className="clear-float"></div>
                            </div>
                          ),
                        )}
                      {!q.iscontributeinrating &&
                        q.questioninputtypeid == 2 &&
                        q.questioninputoption &&
                        q.questioninputoption.map((op) => {
                          const x =
                            q.feedback &&
                            q.feedback.questioninputoptionid ==
                              op.questioninputoptionid;
                          return (
                            <div>
                              <span className="floatleft margin-right-8">
                                <DynamicForm
                                  className="width50"
                                  fields={radioinputconverter({
                                    value: x,
                                    placeholder: "",
                                    label: "",
                                    disabled: !isEnable(),
                                  })}
                                  onChange={() => {}}
                                />
                              </span>
                              <span className="small-dark-secondary margin-bottom-8">
                                {op.optionname}
                              </span>
                              <div className="clear-float"></div>
                            </div>
                          );
                        })}
                      {empform1 && q.feedback && q.feedback.feedback && (
                        <div className="clear-float">
                          <span className="small-dark-secondary t-bold">
                            Comment:{" "}
                          </span>
                          <span className="small-dark-secondary">
                            {q.feedback.feedback}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="clear-float"></div>
                  </Paper>
                </Grid>
              ))}
          </DialogContent>
        </Dialog>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={this.state.openDialog1}
          // onClose={() => this.setState({ openDialog1: false })}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogContent>
            <div style={{ maxHeight: 300, minHeight: 150 }}>
              <p className="small-dark t-bold margin-bottom-4">
                Choose employee to fill form as Peer/Co-worker
              </p>
              {this.state.peersList && this.state.peersList.length > 0 && (
                <div>
                  {/* <DynamicForm
                  fields={multiselectinputconverter({
                    value: this.state.employeeids,
                    placeholder: "Select employees",
                    label: "",
                    options: this.state.peersList || [],
                    idonly: true,
                  })}
                  onChange={(ids) => {
                    this.handleChange("employeeids", ids);
                  }}
                /> */}
                  <div className="margin-bottom-20">
                    {/* <p className="input-label">Designation</p> */}
                    <Select
                      class="form-control"
                      autofocus
                      placeholder="Select employees"
                      isMulti
                      options={this.state.peersList || []}
                      getOptionLabel={(option) => option.displayname}
                      getOptionValue={(option) => option.displayvalue}
                      onChange={(ids) => {
                        this.handleChange("employeeids", ids);
                      }}
                      value={this.state.employeeids}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                </div>
              )}
              {this.state.peersList && this.state.peersList.length == 0 && (
                <div style={{ marginTop: 60 }}>
                  <CallOutNew
                    classnames="bg-light-blue"
                    header="📌 You don't have Peer/Co-worker. Please save form"
                    emoji=""
                    textcolor="#1e8ced"
                  />
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <div>
              <Button
                className="btn btn-secondary-sm-blue margin-right-16"
                variant="outlined"
                onClick={() => this.setState({ openDialog1: false })}
                //  onClick={this.openPeerDialog}
              >
                Cancel
              </Button>
              <Button
                className={
                  this.props.SaveInProgressReducer.issaveinprogress
                    ? "btn btn-secondary-md-grey margin-right-16"
                    : "btn btn-primary-md-blue margin-right-16"
                }
                variant="contained"
                // onClick={() => this.onSave(false)}
                onClick={() => this.ConfirmSave(false)}
              >
                Save
              </Button>
            </div>
          </DialogActions>
        </Dialog>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={this.state.isloading}
          // onClose={() => this.setState({ openDialog: false, empform1: null })}
          aria-labelledby="max-width-dialog-title"
          classes={{
            scrollPaper: "no-shadow bg-transparent",
            paper: "no-shadow bg-transparent",
          }}
        >
          <DialogContent>
            <div
              className="progess-wrapper"
              style={{
                position: "relative",
                width: 120,
                height: 120,
                margin: "0 auto",
                color: "#fff",
              }}
            >
              <CustomLoader />
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={this.state.isConfirmSavedLoading}
          // onClose={() => this.setState({ openDialog: false, empform1: null })}
          aria-labelledby="max-width-dialog-title"
          classes={{
            scrollPaper: "no-shadow bg-transparent",
            paper: "no-shadow bg-transparent",
          }}
        >
          <DialogContent>
            <div
              className="progess-wrapper"
              style={{
                position: "relative",
                width: 120,
                height: 120,
                margin: "0 auto",
                color: "#fff",
              }}
            >
              <CustomLoader />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
      setSaveProgress,
      removeSaveProgress,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(PendingReviews)));
